import Auth from '@aws-amplify/auth';
import { ConsoleLogger as Logger } from '@aws-amplify/core';
import { Button } from '@rmwc/button';
import { TextField, TextFieldHelperText as HelperText } from '@rmwc/textfield';
import { ForgotPassword } from 'aws-amplify-react';
import * as React from 'react';

const logger = new Logger('ForgotPassword');

class CustomForgotPassword extends ForgotPassword {
    constructor(props) {
        super(props);

        this.send = this.send.bind(this);
        this.submit = this.submit.bind(this);

        this._validAuthStates = ['forgotPassword'];
        this.state = {
            username: '',
            code: '',
            password: '',
            delivery: null,
        };
    }

    handleInputChange = event => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    send(event) {
        const { authData = {} } = this.props;
        let username = this.state.username || authData.username;

        username = username.toLowerCase();

        event.preventDefault();

        if (!Auth || typeof Auth.forgotPassword !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPassword(username)
            .then(data => {
                logger.debug(data);
                this.setState({ delivery: data.CodeDeliveryDetails });
            })
            .catch(err => this.error(err));
    }

    submit(event) {
        const { authData = {} } = this.props;
        const { code, password } = this.state;
        const username = this.state.username || authData.username;

        event.preventDefault();

        if (!Auth || typeof Auth.forgotPasswordSubmit !== 'function') {
            throw new Error('No Auth module found, please ensure @aws-amplify/auth is imported');
        }
        Auth.forgotPasswordSubmit(username, code, password)
            .then(data => {
                logger.debug(data);
                this.changeState('signIn');
                this.setState({ delivery: null });
            })
            .catch(err => this.error(err));
    }

    sendView() {
        return (
            <form className="login-form" onSubmit={this.send}>
                <TextField
                    label="Email"
                    helpText={<HelperText>Enter your email address</HelperText>}
                    outlined={true}
                    name="username"
                    key="username"
                    autoFocus
                    onChange={this.handleInputChange}
                    value={this.state.username}
                />
                <Button
                    type="submit"
                    raised
                    className="login-button mdc-theme--primary-bg mdc-theme--on-primary"
                >
                    Send Code
                </Button>
                <div className="forgot-wrapper">
                    <button className="link-button" onClick={() => this.changeState('signIn')}>
                        Back to Sign In
                    </button>
                </div>
            </form>
        );
    }

    submitView() {
        return (
            <form className="login-form" onSubmit={this.submit}>
                <TextField
                    label="Code"
                    helpText={<HelperText>Code sent via your email</HelperText>}
                    outlined={true}
                    name="code"
                    key="code"
                    onChange={this.handleInputChange}
                    autoComplete="off"
                    value={this.state.code}
                />
                <TextField
                    label="New Password"
                    helpText={<HelperText>Enter your new password</HelperText>}
                    outlined={true}
                    name="password"
                    key="password"
                    type="password"
                    onChange={this.handleInputChange}
                    autoComplete="off"
                    value={this.state.password}
                    pattern="^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?&quot;!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?&quot;!@#%&/\\,><':;|_~`=+\- ]{10,256}$"
                    title="Your new password should be minimum 10 characters long and contain at least one: lowercase letter, uppercase letter, number, and symbol"
                />
                <Button
                    type="submit"
                    raised
                    className="login-button mdc-theme--primary-bg mdc-theme--on-primary"
                >
                    Send Code
                </Button>
                <div className="forgot-wrapper">
                    <button className="link-button" onClick={() => this.changeState('signIn')}>
                        Back to Sign In
                    </button>
                </div>
            </form>
        );
    }

    showComponent() {
        const { authData = {} } = this.props;
        return (
            <div className="login-wrapper">
                <img src="/images/logo-large-en.png" alt="JD Marketplace" />
                <div className="login-paper">
                    <p>Reset your password</p>
                    {this.state.delivery || authData.username ? this.submitView() : this.sendView()}
                </div>
            </div>
        );
    }
}

export default CustomForgotPassword;
